import React, { useCallback, useMemo } from 'react';
import {
  ArrowUp16Regular,
  AddCircle16Regular,
  Star16Regular
} from '@fluentui/react-icons';

/**
 * A component that displays a notification item with an icon and text
 */
const NotificationItem = React.memo(
  ({
    iconName,
    text
  }: {
    iconName: 'arrow' | 'star' | 'plus' | string;
    text: string;
  }) => {
    const getIcon = useCallback(() => {
      const iconProps = {
        className: 'h-4 w-4 text-[#4F46E5] mr-3 flex-shrink-0 align-middle',
        style: { verticalAlign: 'middle' }
      };

      switch (iconName) {
        case 'arrow':
          return <ArrowUp16Regular {...iconProps} />;
        case 'star':
          return <Star16Regular {...iconProps} />;
        case 'plus':
          return <AddCircle16Regular {...iconProps} />;
        default:
          return <Star16Regular {...iconProps} />;
      }
    }, [iconName]);

    const textParts = useMemo(() => {
      const words = text.split(' ');
      const firstWord = words.shift() || '';
      const restOfText = words.join(' ');
      return { firstWord, restOfText };
    }, [text]);

    return (
      <div className="flex items-center">
        {getIcon()}
        <span className="text-base leading-6 text-[#1F2937]">
          <span className="font-bold">{textParts.firstWord}</span>{' '}
          {textParts.restOfText}
        </span>
      </div>
    );
  }
);

NotificationItem.displayName = 'NotificationItem';

export default NotificationItem;
